import "./menuPopover.scss";

import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { PopoverBody } from "reactstrap";

import FocusedPopover from "../../components/popover/FocusedPopover";
import keyConstants from "../../constants/keyConstants";
import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import FormButton from "../form/FormButton";
import { clickWasDropdown } from "../form/utils";
import Icon from "../interface/Icon";
import { withScreenContext } from "../screen/ScreenContext";
import MenuPopoverRow from "./MenuPopoverRow";

class MenuPopover extends PureComponent {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.state = {
      popoverOpen: false
    };
  }

  componentDidMount() {
    this.updatePopoverOpen(this.props.isOpen);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen !== this.state.popoverOpen) {
      this.updatePopoverOpen(nextProps.isOpen);
    }
  }

  componentWillUnmount() {
    this.updatePopoverOpen(false);
  }

  updatePopoverOpen(newValue) {
    this.setState({ popoverOpen: newValue });
  }

  toggle(e) {
    if (!clickWasDropdown(e)) {
      this.props.onCancel();
    }
  }

  onKeyDown(e) {
    if (e.key === keyConstants.Enter && this.props.onEnter) {
      this.props.onEnter();
    }
  }

  renderNormalBody() {
    const {
      title,
      onOk,
      children,
      buttonLabel,
      topDescription,
      bottomDescription,
      showCancel,
      onCancel,
      isVerticalLayout
    } = this.props;
    return (
      <div className="menuPopoverContainer" onKeyDown={this.onKeyDown}>
        {isVerticalLayout ? (
          <MenuPopoverRow className="middleAlign">
            {title}
            {showCancel ? (
              <Icon className="menuPopoverCloseIcon" icon="interfaceClose" color="iconMono" onClick={onCancel} />
            ) : null}
          </MenuPopoverRow>
        ) : null}
        {topDescription ? <MenuPopoverRow>{topDescription}</MenuPopoverRow> : null}
        <div className={`menuPopoverInputContainer${isVerticalLayout ? " vertical" : ""}`}>
          {!isVerticalLayout ? <div className="menuPopoverInlineTitle">{title}</div> : null}
          {children}
          {!bottomDescription && !isVerticalLayout ? (
            <FormButton className="" label={buttonLabel} rightAlign={true} onClick={onOk} primary={true} />
          ) : null}
        </div>
        {bottomDescription ? <MenuPopoverRow>{bottomDescription}</MenuPopoverRow> : null}
        {bottomDescription || isVerticalLayout ? (
          <MenuPopoverRow className="rightAlign lastRow">
            <FormButton disabled={isNil(onOk)} label={buttonLabel} rightAlign={true} onClick={onOk} primary={true} />
          </MenuPopoverRow>
        ) : null}
      </div>
    );
  }

  renderIosBody() {
    const { title, onOk, children, buttonLabel, description, onCancel } = this.props;
    return (
      <div className="menuPopoverContainer" onKeyDown={this.onKeyDown}>
        {title ? <MenuPopoverRow className="title">{title}</MenuPopoverRow> : null}
        {description ? <MenuPopoverRow>{description}</MenuPopoverRow> : null}
        <MenuPopoverRow>{children}</MenuPopoverRow>
        <MenuPopoverRow className="buttons">
          <FormButton label="Cancel" onClick={onCancel} primary={false} />
          <FormButton disabled={isNil(onOk)} label={buttonLabel} onClick={onOk} primary={true} />
        </MenuPopoverRow>
      </div>
    );
  }

  renderPopover() {
    const { target } = this.props;

    const isIos = preprocessorQuery.isIos();

    const classes = ["menuPopover", isIos ? "iOsPopover" : ""].join(" ");

    return (
      <FocusedPopover
        className={classes}
        placement="bottom"
        isOpen={this.state.popoverOpen}
        target={target}
        toggle={this.toggle}
        hideArrow={true}
        trigger="legacy"
        boundariesElement="viewport"
        offset={isIos ? "0, 100" : null}
      >
        <PopoverBody onClick={e => e.stopPropagation()}>
          {isIos ? this.renderIosBody() : this.renderNormalBody()}
        </PopoverBody>
      </FocusedPopover>
    );
  }

  render() {
    return this.renderPopover();
  }
}

MenuPopover.defaultProps = {
  buttonLabel: "Ok",
  showCancel: false
};

MenuPopover.propTypes = {
  target: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onOk: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
  children: PropTypeShapes.elementOrArray.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  description: PropTypes.string, // iOs only
  topDescription: PropTypes.string,
  bottomDescription: PropTypes.string,
  showCancel: PropTypes.bool.isRequired,
  isVerticalLayout: PropTypes.bool,

  //#!if iOS === true || harvard === true
  // From withScreenContext
  screenContext: PropTypes.object
  //#!endif
};

let exportedView = MenuPopover;
//#!if iOS === true || harvard === true
exportedView = withScreenContext(MenuPopover);
//#!endif
export default exportedView;
